import React, { ReactNode, createContext, useContext } from 'react'

import { useStickyState, StorageType } from '../hooks/useStickyState'
import { User } from '../types'
import { storageKey } from '../config'

export interface CredentialsProps {
  token: string | null
  refreshToken: string | null
  authentication: User | null
}

const initSecurity = {
  token: null,
  refreshToken: null,
  authentication: null,
}

export const CredentialsContext = createContext<CredentialsProps>(initSecurity)
export const CredentialsContextChange = createContext<
  (value: CredentialsProps | null, storageType: StorageType) => void
>(() => {})

interface Props {
  children: ReactNode
}

export const CredentialsProvider: React.FC<Props> = ({ children }) => {
  const [credentials, setCredentials] = useStickyState<CredentialsProps>(initSecurity, storageKey)

  return (
    <CredentialsContext.Provider value={credentials}>
      <CredentialsContextChange.Provider value={setCredentials}>{children}</CredentialsContextChange.Provider>
    </CredentialsContext.Provider>
  )
}

export const useCredentials = () => {
  const context = useContext(CredentialsContext)

  if (context === undefined) {
    throw new Error('useCredentials must be used within the CredentialsProvider.')
  }

  return context || initSecurity
}

export const useSetCredentials = () => {
  const context = useContext(CredentialsContextChange)

  if (!context) {
    throw new Error('useSetCredentials must be used within the CredentialsProvider.')
  }

  return context
}
